import axios from 'axios';

export default {
  FETCH_MESSAGES ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('common/getAllGreetings')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('messages', JSON.stringify(payload));
                    commit('SET_MESSAGES', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDMESSAGE ({ commit }, messageId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getAllGreetings`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedMessage = payload.filter(x => {
              return x.greetingId.toString() === messageId.toString()
            });

            console.log('found message', selectedMessage)
            commit('SET_SELECTED_MESSAGE', selectedMessage[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_MESSAGE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
          payload.csvCorporationId = payload.csvCorporationId.toString()
            commit('TOGGLE_LOADING', true);
            console.log("add Message payload : ", payload);
            axios.post('common/insertGreetings', payload)
                .then((response) => {
                    console.log('ADD_MESSAGE action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_ARTICLE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_MESSAGE({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
          payload.csvCorporationId = payload.csvCorporationId.toString()
            commit('TOGGLE_LOADING', true);
            axios.put('/common/updateGreetings', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_MESSAGE action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/actions.js